
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ListaBase extends Vue {
  @Prop({ type: Array })
  public lista!: Array<any>;

  @Prop({ type: Array })
  public listaAcoes!: Array<any>;

  @Prop({ type: Array })
  public headers!: Array<any>;

  @Prop({ type: Array })
  public listaValues!: Array<any>;

  @Prop({ type: Boolean })
  public loading!: boolean;

  private page = 0;
}
